<template>
	<div class="new-message margin-tb padding-tb-3x">
		<form @submit.prevent="addMessage">
			<label for="new-message"></label>
			<input type="text" name="new-message" v-model="newMessage"/>
			<button class="send-button">Send</button>
			<p class="error" v-if="error">{{ error }}</p>
		</form>
		
	</div>
</template>


<script>
	import { db } from '../../util/firebase';

	export default {
		name: 'ChatInput',
		props: ['name'],
		data() {
			return {
				newMessage: undefined,
				error: undefined
			};
		},
		methods: {
			addMessage() {
				if (this.newMessage) {
					db.collection('message').add({
						content: this.newMessage,
						name: this.name,
						timestamp: Date.now()

					}).catch(err => {
						console.log(err);
					})

					this.newMessage = '';
					this.error = '';
				} else {
					this.error = 'No message';
				}	
			}
		}
	}
</script>

<style lang="less" scoped>
	form {
		text-align: center;
	}
	.new-message {
		text-align: left;	
	}
	.error {
		color: rgb(192, 42, 42);
	}
	.send-button {
		width: 84px;
		height: 56px;
		background-color: #fdfdfd;
		font-family: 'Michroma';
	}
	input {
		width: 400px;
		height: 57px;
		outline: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/chat/ChatInput.vue